var render = function render(){var _vm=this,_c=_vm._self._c;return _c('font-awesome-icon',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",value:(_vm.title),expression:"title",modifiers:{"hover":true}}],style:({ color: _vm.color, fontSize: _vm.size, verticalAlign: 'sub' }),attrs:{"icon":"exclamation-triangle","role":"button"}})
}
var staticRenderFns = []

export { render, staticRenderFns }